const withStaticProperties = function(component, staticProps) {
  const next = typeof component === "function" ? component : { ...component };
  Object.assign(next, staticProps);
  return next;
};
export {
  withStaticProperties
};
//# sourceMappingURL=withStaticProperties.js.map
